import { React, Fragment, memo, useEffect, useState } from 'react'
import {
  BodyText,
  HeadingText,
  Button,
  V2PersonalinfoIcon,
  V2InformationIcon,
  V2WalletIcon,
  Row,
  Divider,
  Col,
  CaptionText,
} from '@paypalcorp/pp-react'

import { Message } from '@paypalcorp/worldready-react'
import { fptiCustomImpression, fptiCustomClick } from '../../../utils'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
import serverData from '../../../utils/server-data'

import {
  DATA_CORRECTION_ACCOUNT_URL,
  DATA_CORRECTION_WALLET_URL,
  DATA_CORRECTION_ACCOUNT_NATIVE,
  DATA_CORRECTION_WALLET_NATIVE,
} from '../../../constants/constants'

const DataCorrection = memo(() => {
  const correctionFpti = DATAPRIVACY_FPTI.CORRECTION

  const [impressionDone, setImpressionDone] = useState(false)
  const { isNative = false } = serverData
  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(correctionFpti.IMPRESSION)
    }
  }, [])
  const clickOnAccountSettingsBtn = (event) => {
    event.preventDefault()
    fptiCustomClick(correctionFpti.SETTINGS_BTN)
    location.href = isNative
      ? DATA_CORRECTION_ACCOUNT_NATIVE
      : DATA_CORRECTION_ACCOUNT_URL
  }
  const clickOnWalletBtn = (event) => {
    event.preventDefault()
    fptiCustomClick(correctionFpti.WALLET_BTN)
    location.href = isNative
      ? DATA_CORRECTION_WALLET_NATIVE
      : DATA_CORRECTION_WALLET_URL
  }
  return (
    <Fragment>
      <Row className="dataPrivacy-row">
        <Col>
          <HeadingText id="dataCorrectionHeader" size="lg">
            <Message id="dataCorrection.section.heading" />
          </HeadingText>
        </Col>
      </Row>

      <Divider theme="v2" />

      <Row className="dataPrivacy-row">
        <Col xs={2} md={1} className="text-center">
          <V2PersonalinfoIcon size="lg" />
        </Col>
        <Col>
          <HeadingText size="sm">
            <Message id="dataCorrection.section.subheader.title" />
          </HeadingText>
          <BodyText>
            {isNative ? (
              <Message id="dataCorrection.section.subheader.mobile.desc" />
            ) : (
              <Message id="dataCorrection.section.subheader.desc" />
            )}
          </BodyText>
          <div className="dataPrivacy-correction-btn-row">
            <Button
              theme="v2"
              id="settingsBtn"
              size="sm"
              secondary
              onClick={clickOnAccountSettingsBtn}
            >
              {isNative ? (
                <Message id="dataCorrection.section.account.mobile.button" />
              ) : (
                <Message id="dataCorrection.section.account.button" />
              )}
            </Button>
          </div>
        </Col>
      </Row>
      <div className="dataPrivacy-correction-info-row">
        <V2InformationIcon className="info-item" size="sm" />

        <CaptionText className="info-item">
          <Message id="dataCorrection.section.account.info" />
        </CaptionText>
      </div>
      <Divider />
      <Row className="dataPrivacy-row">
        <Col xs={2} md={1} className="text-center">
          <V2WalletIcon size="lg" />
        </Col>
        <Col>
          <HeadingText size="sm">
            <Message id="dataCorrection.section.subheader.secondtitle" />
          </HeadingText>
          <BodyText>
            <Message id="dataCorrection.section.subheader.seconddesc" />
          </BodyText>
          <div className="dataPrivacy-correction-btn-row">
            <Button
              theme="v2"
              id="walletBtn"
              size="sm"
              secondary
              onClick={clickOnWalletBtn}
            >
              {isNative ? (
                <Message id="dataCorrection.section.wallet.mobile.button" />
              ) : (
                <Message id="dataCorrection.section.wallet.button" />
              )}
            </Button>
          </div>
        </Col>
      </Row>

      <Divider />
    </Fragment>
  )
})
DataCorrection.displayName = 'DataCorrection'
export default DataCorrection
